import { Route, Switch, useRouteMatch } from "react-router-dom";

import Layout from "@/containers/Layout";
import { searchSectionRoutes } from "@/hooks/useSearchSectionRoutes";
import { RELATIVE_PATHS, ROUTES } from "@/routes_new";
import MentionLayout from "@/views/MentionsView/MentionLayout";

import AnchorRedirect from "../AnchorRedirect";
import EditAlertView from "../EditAlertView";
import MentionsListView from "./List";
import HiddenMentionsView from "../HiddenMentionsView";
import { FEATURE } from "@/features";
import { useHasFeature } from "@/hooks/useHasFeature";
import Unavailable from "../archive/unavailable";
import { MentionsSheetView } from "@/views/MentionsSheet";
import MentionsInsightsReachView from "./InsightsReach";
import MentionsInsightsSentimentView from "./InsightsSentiment";
import MentionsInsightsResultsView from "./InsightsResults";
import LegacyInsightsRedirect from "./LegacyInsightsRedirect";

export const MentionsViewInner = ({ url = ROUTES.MENTION_DETAIL_ORGID }) => {
  const hasPermission = useHasFeature(
    FEATURE.HAS_READ_EXPIRED_SEARCHES_MENTIONS_FEATURE
  );
  const isArchivePage = !!useRouteMatch(ROUTES.ARCHIVE_DETAIL_ORGID);
  const shouldRenderUnavailablePage = !hasPermission && isArchivePage;
  const section = searchSectionRoutes(url);

  return (
    <Switch>
      <Route path={url}>
        <Switch>
          <Route
            exact
            path={`${url}${RELATIVE_PATHS.ALERT_SETTINGS}/`}
            component={EditAlertView}
          />
          <Route
            exact
            path={`${url}${RELATIVE_PATHS.ALERT_SETTINGS}/hidden`}
            component={HiddenMentionsView}
          />
          <Route exact path={`${url}${RELATIVE_PATHS.ALERT_INSIGHTS}/`}>
            <LegacyInsightsRedirect url={url} />
          </Route>
          <Route>
            {shouldRenderUnavailablePage ? (
              <Unavailable />
            ) : (
              <>
                <MentionLayout url={url}>
                  <Switch>
                    <Route
                      component={MentionsInsightsReachView}
                      path={`${url}${RELATIVE_PATHS.ALERT_INSIGHTS_REACH}/`}
                    />
                    <Route
                      component={MentionsInsightsSentimentView}
                      path={`${url}${RELATIVE_PATHS.ALERT_INSIGHTS_SENTIMENT}/`}
                    />
                    <Route
                      component={MentionsInsightsResultsView}
                      path={`${url}${RELATIVE_PATHS.ALERT_INSIGHTS_RESULTS}/`}
                    />
                    <Route
                      path={ROUTES.MENTIONS_ANCHOR_ORGID}
                      component={AnchorRedirect}
                      exact
                    />
                    <Route component={MentionsListView} path={url} />
                  </Switch>
                </MentionLayout>

                <Route
                  exact
                  component={MentionsSheetView}
                  path={[
                    section.detailPeriod,
                    section.insightsReachPeriod,
                    section.insightsSentimentPeriod,
                    section.insightsResultsPeriod,
                  ]}
                />
              </>
            )}
          </Route>
        </Switch>
      </Route>
    </Switch>
  );
};

const MentionsView = (props: { url?: string }) => (
  <Layout>
    <MentionsViewInner {...props} />
  </Layout>
);

export default MentionsView;
